<template>
  <ModalBase @close-modal="() => closeTermModal()">
    <div class="modalLayout">
      <div class="modalContainer">
        <p class="modalTitle">
          マイナビRESIDENT 利用規約
        </p>
        <div>
          <template v-for="term in termData" :key="term.title">
            <p class="termTitle">◆{{ term.title }}</p>
            <div v-html="term.html"></div>
          </template>
          <div class="right" v-html="termDate"></div>
        </div>
      </div>
    </div>
  </ModalBase>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/runtime-core'
import ModalBase from '../genenral/ModalBase.vue'
import { termData, termDate } from '@/views/Terms.vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'ModalTerms',

  components: {
    ModalBase
  },

  props: {
    closeModal: {
      type: Function as PropType<() => void>,
      required: true
    }
  },

  setup(props) {
    const store = useStore()

    const closeTermModal = () => {
      store.commit('unFixBody')
      props.closeModal()
    }

    return {
      closeTermModal,
      termData,
      termDate
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

::v-deep .modal {
  height: calc(100% + 40px);
  width: 100%;
  max-width: 712px;
  margin-top: 20px;
  padding-right: 0;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @include mixins.media() {
    height: 100%;
    padding: 44px 40px 40px 88px;
  }
}
.modalLayout {
  width: 100%;
  height: 100%;
  padding: 0 36px 72px;
  overflow-y: auto;
  @include mixins.media() {
    padding: 0;
  }
}
.modalContainer {
  @include mixins.media() {
    padding-right: 40px;
  }
}
.modalTitle {
  font-size: 1.8rem;
  text-align: center;
  margin-bottom: 28px;
}
::v-deep(p, li) {
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  > a {
    color: var.$color-main-text;
  }
}
.termTitle {
  font-size: 1.4rem;
  margin-top: 1.5em;
}
::v-deep(p + .numList) {
  margin-top: 0.5em;
}

::v-deep(.numList) {
  margin-left: 9px;
  padding-left: 9px;
  li {
    counter-increment: cnt;
    text-indent: -9px;
    &::before {
      content: counter(cnt) '.';
      display: inline-block;
      margin-right: 7px;
    }
    + li {
      margin-top: 0.5em;
    }
    > ol {
      margin-top: 0.5em;
    }
  }

  &.-paren {
    margin-left: 12px;
    padding-left: 12px;
    li {
      text-indent: -12px;
      counter-increment: cnnt;
    }
    li::before {
      content: '(' counter(cnnt) ')';
      display: inline-block;
      margin-right: 7px;
    }
  }
}
::v-deep(.right) {
  text-align: right;
  @include mixins.media() {
    margin-top: 44px;
  }
  p {
    margin-top: 14px;
    @include mixins.media() {
      margin-top: 20px;
    }
  }
  margin-bottom: 37px;
}
</style>
